import React, { Component } from 'react';
import { Button } from '@trevor/ui-components';
import { postFormData } from '@/util/helpers/ajax-helpers';
import style from '../../css/module/credentials.css';

class UploadFile extends Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
    this.fileChosen = this.fileChosen.bind(this);
    this.fileChooser = this.fileChooser.bind(this);
  }

  fileUpdated() {
    const { onChange } = this.props;
    const file = this.fileInput.current.files[0];
    const formData = new FormData();
    formData.append('file', file);
    postFormData('/file', formData)
      .then(function (json) {
        onChange(json.content, file.name);
      })
      .catch(() => {
        // TODO: handle error
        alert('problem uploading file');
      });
  }

  fileChosen() {
    const { onChange } = this.props;
    return (
      <Button
        variant="secondary"
        onClick={() => onChange(null)}
        disabled={this.props.disabled}
      >
        remove
      </Button>
    );
  }

  fileChooser() {
    return (
      <input
        className={style.fileUploadInput}
        type="file"
        style={{
          marginTop: '5px',
          height: '100%',
          maxWidth: '85px',
          color: 'transparent',
        }}
        onChange={() => this.fileUpdated()}
        ref={this.fileInput}
        disabled={this.props.disabled}
      />
    );
  }

  render() {
    const { content } = this.props;
    return (
      <div className={style.uploadContainer}>
        {content ? this.fileChosen() : this.fileChooser()}
      </div>
    );
  }
}

export default UploadFile;
